import colors from "../utils/colors";
import Appointment from "../features/appointments";
import Heading from "../components/typography/Heading";
import { Box, Text, Flex } from "@chakra-ui/react";

const Appointments = () => {
  return (
    <div
      className="p-[10px] h-full w-full"
      style={{ backgroundColor: colors.lightGrey }}
    >
      <Appointment />
    </div>
  );
};

export default Appointments;
